export function LegalDocument({ page }) {
  return (
    <article className="legal-document">
      <header>
        <h1>{page.title.replace(" | Aspirant", "")}</h1>
        <p>{page.description}</p>
      </header>
      {page.sections?.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          {section.body?.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          {section.bullets?.length ? (
            <ul>
              {section.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
          ) : null}
        </section>
      ))}
    </article>
  );
}
